import * as t from 'io-ts'

/**
 * A codec that can decode a boolean or an integer. 
 * @returns boolean
 * @example
 * boolOrIntCodec.decode(0) // => success(true)
 * boolOrIntCodec.decode(1) // => success(true)
 * boolOrIntCodec.decode(true) // => success(true)
 * boolOrIntCodec.decode(false) // => success(false)
 * 
 * boolOrIntCodec.decode(2) // => failure
 * boolOrIntCodec.decode('true') // => failure
 * boolOrIntCodec.decode('false') // => failure
 * boolOrIntCodec.decode('0') // => failure
 * boolOrIntCodec.decode('1') // => failure
 * boolOrIntCodec.decode('2') // => failure
 */
const boolOrIntCodec = new t.Type<boolean, boolean, unknown>(
    'boolOrIntCodec',
    (input: unknown): input is boolean => typeof input === 'boolean',
    (input, context) => {
        if (typeof input === 'boolean') return t.success(input)
        if (input === 0 || input === 1) return t.success(input === 1)
        return t.failure(input, context)
    },
    Boolean
)

export default boolOrIntCodec;